<template>
  <div>
    <h2 class="page-title">我的 SN</h2>
    <div class="card-panel">
      <div class="table-tools">
        <div>
          <h3 class="section-title">SN 记录</h3>
          <p class="section-desc" style="margin-bottom:0;">查看已创建 SN，预览二维码和条形码，或导出 CSV。</p>
        </div>
        <div class="action-row">
          <el-button type="primary" @click="loadData">刷新</el-button>
          <el-button type="success" @click="exportCsv">导出 CSV</el-button>
        </div>
      </div>
      <div v-if="rows.length" class="table-scroll">
        <el-table :data="rows" width="100%">
          <el-table-column prop="formattedSn" label="格式化SN" min-width="220" />
          <el-table-column prop="segmentCode" label="SN段1" width="100" />
          <el-table-column prop="customCode" label="SN段2" width="120" />
          <el-table-column prop="verifyCode" label="验证码" width="100" />
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="scope">
              <el-tag :type="scope.row.status === 'disabled' ? 'danger' : 'success'">
                {{ scope.row.status === 'disabled' ? '禁用' : '正常' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="productName" label="产品名" />
          <el-table-column prop="launchDate" label="投放日期" />
          <el-table-column prop="launchRegion" label="投放地区" />
          <el-table-column prop="lastVerifiedAt" label="最后验证时间" min-width="180" />
          <el-table-column prop="lastVerifyLocation" label="最后验证地区" min-width="160" />
          <el-table-column prop="verifyCount" label="验证次数" width="100" />
          <el-table-column label="操作" min-width="360">
            <template slot-scope="scope">
              <div class="table-actions">
                <el-button size="mini" @click="previewQr(scope.row)">二维码</el-button>
                <el-button size="mini" @click="previewBarcode(scope.row)">条形码</el-button>
                <el-button size="mini" @click="copyText(scope.row.qrUrl, '二维码链接已复制')">复制二维码链接</el-button>
                <el-button size="mini" @click="copyText(scope.row.sn, 'SN已复制')">复制SN</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  :disabled="scope.row.status === 'disabled'"
                  @click="disableSn(scope.row)"
                >
                  禁用
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else class="empty-panel">暂无 SN 记录</div>
    </div>

    <el-dialog title="二维码预览" :visible.sync="qrDialogVisible" width="360px">
      <div class="preview-card">
        <canvas ref="qrCanvas" width="220" height="220"></canvas>
        <div class="code-text" style="margin-top:12px;">{{ currentContent }}</div>
      </div>
    </el-dialog>

    <el-dialog title="条形码预览" :visible.sync="barcodeDialogVisible" width="520px">
      <div class="preview-card">
        <svg ref="barcode"></svg>
        <div class="code-text" style="margin-top:12px;">{{ currentSn }}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
import QRCode from 'qrcode'
import { disableMySN, getExportUrl, getMySNs } from '../../api/vendor'

export default {
  data() {
    return {
      rows: [],
      qrDialogVisible: false,
      barcodeDialogVisible: false,
      currentContent: '',
      currentSn: '',
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const { data } = await getMySNs()
      this.rows = data
    },
    exportCsv() {
      const token = localStorage.getItem('token')
      window.open(`${getExportUrl()}?token=${encodeURIComponent(token)}`, '_blank')
    },
    async previewQr(row) {
      this.currentContent = row.qrUrl
      this.qrDialogVisible = true
      await this.$nextTick()
      QRCode.toCanvas(this.$refs.qrCanvas, row.qrUrl, { width: 220, margin: 1 })
    },
    previewBarcode(row) {
      this.currentSn = row.sn
      this.barcodeDialogVisible = true
      this.$nextTick(() => {
        JsBarcode(this.$refs.barcode, row.sn, {
          format: 'CODE128',
          displayValue: true,
          height: 70,
          margin: 10,
        })
      })
    },
    async copyText(text, message) {
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success(message)
      } catch (error) {
        this.$message.error('复制失败')
      }
    },
    async disableSn(row) {
      try {
        await this.$confirm(`确认禁用 SN ${row.formattedSn} 吗？禁用后将无法验证通过。`, '提示', {
          type: 'warning',
        })
        await disableMySN(row.id)
        this.$message.success('SN 已禁用')
        this.loadData()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(error.response?.data?.message || '禁用失败')
        }
      }
    },
  },
}
</script>
